









































import { Vue, Component } from 'vue-property-decorator';
import VoteButton from './components/VoteButton.vue';
import * as config from './config';
import { getdetail } from './api';
import { appShare, wxShareInfo } from '@/common/ts/common';
import Org from './components/Org.vue';

@Component({
  name: 'DetailPage',
  components: {
    VoteButton,
    Org,
  },
})
export default class DetailPage extends Vue {
  mustWeChat: boolean = true;
  imgUrl: string = require('./img/banner.jpg');
  option = config.OPTHINES;
  detailData = {};
  created() {
    getdetail(this.option.voteName, Number(this.$route.query.id)).then(
      (res: any) => (this.detailData = res.data),
    );
    this.$addPv(382);
    appShare({
      title: '最美生态环保志愿者评选',
      url: window.location.href,
      subtitle: '最美生态环保志愿者评选',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      classId: -1,
      id: -1,
      type: 3,
    });
    wxShareInfo({
      title: '最美生态环保志愿者评选',
      subtitle: '最美生态环保志愿者评选',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }

  votSuccess(res: any) {
    console.log(res);
    getdetail(this.option.voteName, Number(this.$route.query.id)).then(
      (res: any) => (this.detailData = res.data),
    );
  }
}
